/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PregnancyCase from './pregnancy-case';
import PregnancyCaseDetail from './pregnancy-case-detail';
import PregnancyCaseUpdate from './pregnancy-case-update';
import PregnancyCaseDeleteDialog from './pregnancy-case-delete-dialog';

const PregnancyCaseRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PregnancyCase />} />
    <Route path="new" element={<PregnancyCaseUpdate />} />
    <Route path=":id">
      <Route index element={<PregnancyCaseDetail />} />
      <Route path="edit" element={<PregnancyCaseUpdate />} />
      <Route path="delete" element={<PregnancyCaseDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PregnancyCaseRoutes;
